export enum PAGE_TOPBAR_UTILITY_VISIBILITY {
  DESKTOP_ONLY = 'desktop_only',
  ALWAYS = 'always',
}
